import { motion } from "framer-motion";
import { MapPin, Phone, Clock, ShoppingBag } from "lucide-react";
import { CONTACT } from "../data/menu";

export const Footer = () => (
  <footer id="visit" data-testid="site-footer" className="relative overflow-hidden text-white" style={{ background: "var(--navy)" }}>
    <div className="max-w-[1500px] mx-auto px-6 lg:px-12 pt-24 lg:pt-32">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
        <div className="flex items-center gap-5">
          <img src="/logo-white.png" alt="Lucky Corner Fish, Chippery & Souvláki" className="h-20 w-20 lg:h-24 lg:w-24 object-contain" />
          <div>
            <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-[var(--azure)] block">Visit Us</span>
            <span className="font-display text-2xl lg:text-3xl">Lucky Corner Fish, Chippery &amp; Souvláki</span>
          </div>
        </div>
        <span className="h-px flex-1 bg-white/15 hidden md:block max-w-[280px]" />
      </div>

      <div className="grid md:grid-cols-3 gap-12 lg:gap-16 pb-20">
        <div>
          <div className="flex items-center gap-3 text-[var(--azure)] mb-4">
            <MapPin size={18} />
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase">Find Us</span>
          </div>
          <p className="font-display text-2xl lg:text-3xl leading-tight">{CONTACT.address}</p>
          <a
            href={`https://maps.google.com/?q=${encodeURIComponent(CONTACT.name + " " + CONTACT.address)}`}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-directions"
            className="inline-block mt-5 font-mono text-[12px] tracking-[0.15em] uppercase text-white/70 border-b border-white/30 pb-1 transition-colors hover:text-white"
          >
            Get Directions →
          </a>
        </div>

        <div>
          <div className="flex items-center gap-3 text-[var(--azure)] mb-4">
            <Phone size={18} />
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase">Order by Phone</span>
          </div>
          <a href={CONTACT.phoneHref} data-testid="footer-phone" className="font-display text-2xl lg:text-3xl hover:text-[var(--sky)] transition-colors">
            {CONTACT.phone}
          </a>
          <p className="mt-3 text-white/50 text-sm">Call ahead — we'll have it hot and ready.</p>
          <a
            href={CONTACT.websiteHref}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-website"
            className="inline-block mt-4 font-mono text-[11px] tracking-[0.18em] uppercase text-white/70 border-b border-white/30 pb-1 transition-colors hover:text-white"
          >
            {CONTACT.website}
          </a>
          <a
            href={CONTACT.orderUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-order"
            className="mt-6 inline-flex items-center gap-2 rounded-full px-6 py-3 text-white text-[12px] font-mono tracking-[0.15em] uppercase transition-transform duration-300 hover:scale-[1.04] active:scale-95"
            style={{ background: "var(--azure)" }}
          >
            <ShoppingBag size={15} strokeWidth={2.4} />
            Online Order
          </a>
        </div>

        <div>
          <div className="flex items-center gap-3 text-[var(--azure)] mb-4">
            <Clock size={18} />
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase">Opening Hours</span>
          </div>
          <ul className="space-y-2">
            {CONTACT.hours.map((h) => (
              <li key={h.day} className="flex justify-between text-sm border-b border-white/10 pb-2">
                <span className="text-white/70">{h.day}</span>
                <span className="font-mono text-white/90">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>

    {/* typographic stamp */}
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
      className="border-t border-white/10 overflow-hidden"
    >
      <h2 className="font-display font-black text-[19vw] leading-[0.8] tracking-tighter text-center whitespace-nowrap px-4 py-8 select-none" style={{ color: "rgba(255,255,255,0.06)" }}>
        LUCKY CORNER
      </h2>
    </motion.div>

    <div className="border-t border-white/10">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row justify-between items-center gap-3">
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/40">
          © {new Date().getFullYear()} Lucky Corner Fish, Chippery &amp; Souvláki · {CONTACT.suburb}
        </span>
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/40">
          Καλή όρεξη · Greek family run
        </span>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-3 text-center">
        <span data-testid="footer-credit" className="font-mono text-[9px] tracking-[0.2em] uppercase text-white/30">
          Created by ClientSpark · Sachin Khumra
        </span>
      </div>
    </div>
  </footer>
);
